
const AlertBar = ({msg}) => {
    return (
        <div className="alert-error">
            <p>{msg}</p>
        </div>
    )
}

export default AlertBar;